/**
 * A function to create a log object for the 'referralsReferrerClick' event (evid: 301)
 *
 * Event description: Fires on actions done by referring users
 *
 * @param {referralsReferrerClickParams} params - The parameters for this event
 * @property {string} value - Login to refer, Copy link, Link Text Input Click, Share, Refer (mobile)
 * @return {LogObject<referralsReferrerClickParams>} LogObject<referralsReferrerClickParams>
 */
export function referralsReferrerClick(params) {
    return { evid: 301, src: 163, endpoint: 'referrals-uou', params: params };
}
/**
 * A function to create a log object for the 'referralsReferredFriendAction' event (evid: 302)
 *
 * Event description: Fires on actions by referred friend
 *
 * @param {referralsReferredFriendActionParams} params - The parameters for this event
 * @property {string} value - Get Reward, Copy code, Coupon Text Input Click, Signup, Go to home
 * @return {LogObject<referralsReferredFriendActionParams>} LogObject<referralsReferredFriendActionParams>
 */
export function referralsReferredFriendAction(params) {
    return { evid: 302, src: 163, endpoint: 'referrals-uou', params: params };
}
/**
 * A function to create a log object for the 'referralsCouponGeneratedAndLoaded' event (evid: 303)
 *
 * Event description: Sent when coupon is generated and displayed for a referred friend
 *
 * @param {referralsCouponGeneratedAndLoadedParams} params - The parameters for this event
 * @property {number} loadTime - Time in seconds it took to generate and load the Coupon
 * @return {LogObject<referralsCouponGeneratedAndLoadedParams>} LogObject<referralsCouponGeneratedAndLoadedParams>
 */
export function referralsCouponGeneratedAndLoaded(params) {
    return { evid: 303, src: 163, endpoint: 'referrals-uou', params: params };
}
//# sourceMappingURL=index.js.map